import { useState } from "react";
import { ChevronUp } from "lucide-react";

import { TableRow } from "@/components/common/table/table";
import { Ellipse } from "@/components/common/svgs";
import { LoadboardDate, LoadboardTableCell, TableWidths, LoadboardTime, LoadboardToggleRow } from "@/components/dataPages/loadboard";
import { CurrencyText, LocationText, TranslatedText, TruncatedText } from "@/components/common/text";
import { cn } from "@/utils/css";
import * as React from "react";
import { getLoadId } from "@/utils/load";
import { formatAge } from "@/utils/date";

export const LoadboardTableRow = ({ load, index, withTruck = false, hideLoadId = false }) => {
    const [isOpen, setIsOpen] = useState(false);
    const idToShow = load.externalLoadId || getLoadId(load.uniqueId);
    const ageWhen = formatAge(load.updatedAt || load.createdAt);

    return (
        <>
            <TableRow
                className={cn("hover:bg-cm-p-surface-hover bg-cm-p-surface overflow-hidden border-t-[1px] border-cm-p-outline border-b-0", {
                    "border-0": !index,
                    "opacity-40": load.isUnavailable,
                })}
                onClick={() => setIsOpen(!isOpen)}
            >
                <LoadboardTableCell className={`${TableWidths[0]} leading-[22px]`} innerClassName="pt-[14px] px-[5px] flex justify-end">
                    <Ellipse isAvailable={load.allowedActions?.length && !load.isUnavailable} />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[1]} text-cm-p-text-secondary`}>{ageWhen}</LoadboardTableCell>
                {withTruck && (
                    <LoadboardTableCell>
                        <TruncatedText className="bg-[#F1F3F3] text-[#172B26] rounded-[20px] font-medium py-[2px] px-2 max-w-full">
                            {load.truckReference?.name || ""}
                        </TruncatedText>
                    </LoadboardTableCell>
                )}
                {!hideLoadId && (
                    <LoadboardTableCell className={`${TableWidths[2]}`}>
                        <TruncatedText>{idToShow}</TruncatedText>
                    </LoadboardTableCell>
                )}
                <LoadboardTableCell className={`${TableWidths[3]}`}>
                    <LocationText city={load.itineraryStops[0]?.stopCity} state={load.itineraryStops[0]?.stopState} truncate />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[4]}`}>
                    <LocationText
                        city={load.itineraryStops[load.itineraryStops.length - 1]?.stopCity}
                        state={load.itineraryStops[load.itineraryStops.length - 1]?.stopState}
                        truncate
                    />
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[5]}`} innerClassName="flex flex-col">
                    <>
                        <LoadboardDate date={load.pickupDate} />
                        <LoadboardTime stop={load.itineraryStops[0]} />
                    </>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[6]}`} innerClassName="flex flex-col">
                    <>
                        <LoadboardDate date={load.deliveryDate} />
                        <LoadboardTime stop={load.itineraryStops[load.itineraryStops.length - 1]} />
                    </>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[7]}`} innerClassName="flex flex-col">
                    <div>{load.loadDistance ? `${Math.round(load.loadDistance)} mi` : "-"}</div>
                    {load.itineraryStops.length > 2 ? (
                        <div className="text-cm-p-text-secondary text-xs/[19px]">
                            {load.itineraryStops.length - 2}{" "}
                            <TranslatedText>{load.itineraryStops.length > 3 ? "stops" : "stop"}</TranslatedText>
                        </div>
                    ) : null}
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[8]}`}>
                    <TruncatedText>{load.brokerInfo?.name ? `${load.brokerInfo.name}` : "-"}</TruncatedText>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[9]}`} innerClassName="justify-end">
                    <div className="flex items-center justify-end">
                        <div className="w-[52px] text-right mr-[10px]">
                            {load.offerRate ? <CurrencyText className="font-semibold text-sm/[19px]" num={load.offerRate} round /> : "-"}
                        </div>
                    </div>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[10]}`} innerClassName="justify-end">
                    <div className="flex items-center justify-end">
                        <div className="w-[60px] text-right mr-[10px]">
                            {load.rpm ? <CurrencyText className="text-sm/[19px] font-normal" num={load.rpm} /> : "-"}
                        </div>
                    </div>
                </LoadboardTableCell>
                <LoadboardTableCell className={`${TableWidths[11]}`} innerClassName="p-2 justify-end">
                    <div className="w-12 h-12 inline-flex justify-center items-center">
                        <ChevronUp
                            className={cn("w-6 transition-transform", {
                                "rotate-180": !isOpen,
                            })}
                        />
                    </div>
                </LoadboardTableCell>
            </TableRow>
            <LoadboardToggleRow load={load} isOpen={isOpen} />
        </>
    );
};
